export function resolveCourseTimezone(profileTimezone) {
  const candidates = [profileTimezone, Intl.DateTimeFormat().resolvedOptions().timeZone, "UTC"];
  for (const timeZone of candidates) {
    if (!timeZone) continue;
    try { new Intl.DateTimeFormat(undefined, { timeZone }); return timeZone; } catch (_) { /* Try the next fallback. */ }
  }
  return "UTC";
}
export function formatCourseDateTime(value, timeZone, locale) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(locale, { timeZone: resolveCourseTimezone(timeZone), month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }).format(date);
}
